import * as FluxUtils from 'flux/utils';

import { AppDispatcher, DispatcherBaseAction } from '../dispatcher/AppDispatcher';
import { ActionConstants } from '../constants/ActionConstants';
import { ScreenshotHelper } from '../utils/ScreenshotHelper';
import { GlobalHelper } from '../utils/GlobalHelper';

// Submodules
import { PDFImage } from '../submodules/app-api/AppAction';

import cf = egr.wcf.cf;
import eaiws = egr.wcf.eaiws;

export interface ArticleItem {
    article: cf.ArticleElement;
    properties: eaiws.basket.ItemProperties;
    image: string | null;
}

interface ArticleStoreState {
    needsUpdate: boolean;
    articleCount: number;
    articleList: Array<ArticleItem>;
}

function justArticleElement(wrapped: ArticleItem): cf.ArticleElement {
    return wrapped.article;
}

class ArticleStoreClass extends FluxUtils.ReduceStore<ArticleStoreState, unknown> {
    public getInitialState(): ArticleStoreState {
        return {
            needsUpdate: false,
            articleCount: 0,
            articleList: []
        };
    }

    public isConsistent(): boolean {
        const state: ArticleStoreState = this.getState();
        for (const article of state.articleList) {
            if (article.properties.article != null && article.properties.article.inconsistencyFlag) {
                return false;
            }
        }
        return true;
    }

    public getArticleElements(): Array<cf.ArticleElement> {
        return this.getState().articleList.map(justArticleElement);
    }

    public async getArticleImages(value: cf.ArticleElement): Promise<Array<PDFImage>> {
        const state: ArticleStoreState = this.getState();
        for (const article of state.articleList) {
            if (article.article.basketId === value.basketId && article.image != null) {
                const uri: string | null = await ScreenshotHelper.getArticleImage(
                    article.article,
                    { width: 200, height: 200, margin: 0, hideSubArticles: true}
                );

                if (uri != null) {
                    return [{uri, width: 200, height: 200, hasDimensions: false}];
                }
            }
        }
        return [];
    }

    public reduce(state: ArticleStoreState, action: DispatcherBaseAction): ArticleStoreState {
        // Note: this function should be `pure` -> we have to return a copy
        // of the current state if some property was changed

        switch (action.actionType) {
            case ActionConstants.SET_LOADED_PROJECT:
                return jQuery.extend({}, state, {
                    articleCount: GlobalHelper.getArticleCount()
                });
            case ActionConstants.ARTICLE_LIST_CHANGED:
                return jQuery.extend({}, state, {
                    needsUpdate: true,
                    articleCount: GlobalHelper.getArticleCount()
                });
            case ActionConstants.ARTICLE_LIST_UPDATE:
                return jQuery.extend({}, state, {
                    needsUpdate: false,
                    articleList: action.value
                });
            case ActionConstants.RESET_PROJECT_RELATED_SETTINGS:
                return jQuery.extend({}, this.getInitialState());
            default:
                break;
        }
        return state;
    }
}

export let ArticleStore: ArticleStoreClass = new ArticleStoreClass(AppDispatcher);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/stores/ArticleStore.ts